import Axios from 'axios';
import { Input } from './toggles.types';

let toggles: Record<string, boolean> = {};

async function loadToggles(input: Input): Promise<void> {
  const fetchToggles = (url: string) => {
    const headers = input.token ? { appToken: 'Basic ' + input.token } : {};
    return Axios.get<Record<string, boolean>>(url, { headers });
  };

  const startPolling = ({ url, refreshInterval, logger }: Input) => {
    setInterval(async () => {
      try {
        input.logger?.debug('atualizando toggles');

        toggles = (await fetchToggles(url)).data;

        input.logger?.debug('toggles: %o', toggles);
      } catch (error) {
        logger?.error('falha na atualização dos toggles: %o', error);
      }
    }, refreshInterval).unref();
  };

  input.logger?.debug('Carregando toggles...');
  toggles = (await fetchToggles(input.url)).data;
  input.logger?.debug('toggles: %o', toggles);

  if (input.refreshInterval > 0) {
    startPolling(input);
  }
}

function isEnabled(toggleName: string) {
  return toggles[toggleName] || false;
}

export { loadToggles, isEnabled };
